if (!customElements.get("swiper-navigation")) {
  customElements.define(
    "swiper-navigation",
    class SwiperNavigation extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.swiperEl = null;
        this.onSwiperInit = this.onSwiperInit.bind(this);
        this.updateArrowVisibility = this.updateArrowVisibility.bind(this);
        this.redirectFocusOnEdge = this.redirectFocusOnEdge.bind(this);
        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.swiperEl?.removeEventListener("swiperinit", this.onSwiperInit);
        this.swiper?.off("slideChange", this.redirectFocusOnEdge);
        this.swiper?.off("progress", this.updateArrowVisibility);
        this.swiper?.off("update", this.updateArrowVisibility);
        this.swiper?.off("slideChange", this.updateArrowVisibility);
        this.buttonPrev?.removeEventListener("click", this.handlePrevClick);
        this.buttonNext?.removeEventListener("click", this.handleNextClick);
      }

      init() {
        const id = this.getAttribute("for");
        if (!id) return;

        this.swiperEl = document.getElementById(id);
        if (!this.swiperEl) return;

        if (this.swiperEl.swiper) {
          this.setup(this.swiperEl.swiper);
        } else {
          this.swiperEl.addEventListener("swiperinit", this.onSwiperInit);
        }
      }

      onSwiperInit(e) {
        this.swiperEl.removeEventListener("swiperinit", this.onSwiperInit);
        this.setup(e.detail[0]);
      }

      setup(swiperInstance) {
        if (!swiperInstance || this.swiper) return;

        this.swiper = swiperInstance;
        this.buttonPrev = this.querySelector(".js-swiper-prev");
        this.buttonNext = this.querySelector(".js-swiper-next");

        if (!this.buttonPrev || !this.buttonNext) return;

        this.buttonPrev.addEventListener("click", this.handlePrevClick);
        this.buttonNext.addEventListener("click", this.handleNextClick);

        this.swiper.on("slideChange", this.redirectFocusOnEdge);
        this.swiper.on("progress", this.updateArrowVisibility);
        this.swiper.on("update", this.updateArrowVisibility);
        this.swiper.on("slideChange", this.updateArrowVisibility);

        this.updateArrowVisibility();
      }

      handlePrevClick(e) {
        e.preventDefault();
        this.swiper?.slidePrev();
      }

      handleNextClick(e) {
        e.preventDefault();
        this.swiper?.slideNext();
      }

      redirectFocusOnEdge() {
        if (!this.swiper) return;
        const { isBeginning, isEnd } = this.swiper;
        const activeElement = document.activeElement;
        if (isBeginning && activeElement === this.buttonPrev) this.buttonNext.focus();
        if (isEnd && activeElement === this.buttonNext) this.buttonPrev.focus();
      }

      updateArrowVisibility() {
        if (!this.swiper) return;
        const { isBeginning, isEnd } = this.swiper;
        this.toggleState(this.buttonPrev, isBeginning);
        this.toggleState(this.buttonNext, isEnd);
      }

      toggleState(el, shouldHide) {
        if (!el) return;
        el.classList.toggle("hide", shouldHide);
        el.setAttribute("aria-hidden", shouldHide ? "true" : "false");
        el.setAttribute("tabindex", shouldHide ? "-1" : "0");
      }
    }
  );
}